import {
    FETCH_TASKS,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILED,
    ACCEPT_TASK,
    CANCEL_TASK,
    USER_SIGN_OUT,
} from "../store/types";

const INITIAL_STATE = {
    tasks: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const tasklistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_TASKS:
            return {
                ...state,
                loading: true
            };
        case FETCH_TASKS_SUCCESS:
            return {
                ...state,
                tasks: action.payload,
                loading: false
            };
        case FETCH_TASKS_FAILED:
            return {
                ...state,
                tasks: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case ACCEPT_TASK: {
            const acceptedId = action.payload?.task?.id || action.payload?.task?.bookingId || action.payload?.bookingId;
            return {
                ...state,
                tasks: Array.isArray(state.tasks) && acceptedId
                    ? state.tasks.filter(t => t && t.id !== acceptedId && t.bookingId !== acceptedId)
                    : state.tasks
            };
        }
        case CANCEL_TASK: {
            const cancelledId = action.payload?.bookingId || action.payload?.id;
            return {
                ...state,
                tasks: Array.isArray(state.tasks) && cancelledId
                    ? state.tasks.filter(t => t && t.id !== cancelledId && t.bookingId !== cancelledId)
                    : state.tasks
            };
        }
        case USER_SIGN_OUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};